export enum EMoveDirection {
  ToTop,
  Up,
  Down,
  ToBottom,
}
